module.exports = __webpack_public_path__ + "media/images/about/yg_1-817d69566bc4fafb28785e8b3e12cff2.jpg";